//////////////////// auth start ///////////////////
export const USER_LOGIN_URL = "auth/login";
export const GET_PERMISSION_URL = "user/retrieve-permissions";
export const REQ_EMAIL = "/auth/forgot-password";
export const RESET_PASSWORD = "/auth/reset-password";
export const NOT_SHOW_AGAIN =
  "/user/users/user-activate-deactivate-pop-up-restrictions";
export const RESEND_MAIL = "/category/Museum/resend-museum-email";
export const USER_LOGOUT = "/auth/logout";
//////////////////// auth end ///////////////////

//////////////////// user prefernce  ///////////////////
export const POP_RESTRICT =
  "/user/users/user-activate-deactivate-pop-up-restrictions";
//////////////////// user prefernce end ///////////////////

//////////////////// profile start ///////////////////
export const LIST_PROFILE = "user/users/user-profile-tab";
export const UPDATE_CREATE_PROFILE =
  "/user/users/create-or-update-user-profile";
export const CHANGE_PROFILE = "/user/users/change-profile-picture";
//////////////////// profile end ///////////////////

//////////////////// Category start ///////////////////
export const CREATE_CATEGORY_URL =
  "/category/Category/create-or-update-primary-category";
export const CREATE_SUB_CATEGORY_URL =
  "/category/Category/create-or-update-category";
export const LIST_CATEGORY_URL = "/category/Category/list-category";
export const LIST_SUB_CATEGORY_URL =
  "/category/Category/get-subcategories-list";
export const SINGLE_CATEGORY_URL = "/category/Category/detail-list-category";
export const DELETE_CATEGORY_URL = "/category/Category/delete-category";
export const CATEGORY_BULK_UPLOAD = "/category/Category/bulk-create-category";
export const CATEGORY_CSV_SAMPLE = "/category/Category/get-csvformat-file";
export const CATEGORY_DROPDOWN_URL = "/category/Category/category-drodown";
export const SUB_CATEGORY_DROPDOWN_URL =
  "/category/Category/get-subcategories-dropdown";
export const ACTIVE_CATEGORY = "/category/Category/active-inactive-category";
export const USED_MUSEUM_LIST = "/category/usedby/get-category-used-by";
export const CATEGORY_PHOTO_SETUP =
  "/category/Category/get-category-photography-details";
export const SUB_CATEGORY_LIST = "/category/Category/get-subcategories-list";
//////////////////// Category end ///////////////////

//////////////////// Material start ///////////////////
export const CREATE_MATERIAL_URL =
  "/category/Material/create-or-update-material";
export const LIST_MATERIAL_URL = "/category/Material/list-material";
export const SINGLE_MATERIAL_URL = "/category/Material/detail-list-material";
export const DELETE_MATERIAL_URL = "/category/Material/delete-material";
export const MATERIAL_DROPDOWN = "/category/Material/material-dropdown";
export const MATERIAL_ACTIVE =
  "/category/Material/activate-inactivate-material";
export const USED_MATERIAL_LIST = "/category/usedby/get-material-used-by";
//////////////////// Material end ///////////////////

//////////////////// Material Group start ///////////////////
export const CREATE_MATERIAL_GROUP =
  "/category/Material_Group/create-or-update-material-group";
export const LIST_MATERIAL_GROUP_URL =
  "/category/Material_Group/material_group_list";
export const MATERIAL_GROUP_DETAIL =
  "/category/Material_Group/material_group_details";
export const MATERIAL_GROUP_DELETE =
  "/category/Material_Group/delete_material_group";
export const MATERIAL_GROUP_DROPDOWN =
  "/category/Material_Group/material_group_dropdown";
//////////////////// Material Group end ///////////////////

//////////////////// Museum start ///////////////////
export const CREATE_MUSEUM = "category/Museum/create-or-update-museum";
export const DELETE_MUSEUM = "/category/Museum/delete-museum";
export const DETAIL_LIST_MUSEUM = "/category/Museum/museum-details";
export const MUSEUM_DROPDOWN = "/category/Museum/museum-dropdown";
export const MUSEUM_LIST = "/category/Museum/museum-list";
export const ACTIVE_MUSEUM = "/category/Museum/museum-active-deactive";

//////////////////// Museum end ///////////////////

//////////////////// Role start ///////////////////
export const CREATE_ROLE_URL = "/user/roles/create-or-update-role";
export const DELETE_ROLE = "/user/roles/destroy-role";
export const LIST_ROLE = "/user/roles/retrieve-roles";
export const ROLE_INFO = "/user/roles/retrieve-role-info";
export const ROLE_DROPDOWN = "user/roles/role-list-dropdown";
//////////////////// Role end ///////////////////

//////////////////// Group start ///////////////////
export const CREATE_GROUP_URL = "/user/groups/create-or-update-group";
export const DELETE_GROUP = "/user/groups/destroy-group";
export const LIST_GROUP = "/user/groups/retrieve-groups";
export const GROUP_INFO = "/user/groups/retrieve-group-info";
export const GROUP_DROPDOWN = "/user/groups/group-list-dropdown";
//////////////////// Group end ///////////////////

//////////////////// User start ///////////////////
export const CREATE_USER = "/user/users/create-or-update-user-by-admin";
export const USER_LIST = "/user/users/retrieve-users";
export const USER_DETAILS = "/user/users/retrieve-user-info";
export const RESET_PASSWORD_PROFILE = "/user/users/create-or-update-password";
export const USER_RESET_PASSWORD = "/user/users/create-or-update-password";
export const SWITCH_MUSUEM_URL = "/user/users/switch-museum";
export const FCM_TOKEN = "/user/users/update_user_fcm_token";
export const USER_IS_ACTIVE = "/user/users/activate-or-deactivate-users";
export const USER_DROPDOWN = "/user/users/get-user-full-name-dropdown";
export const USER_LAST_SCREEN = "/user/users/update-user-last-screen";
//////////////////// User end ///////////////////

//////////////////// Object start ///////////////////
export const CREATE_OBJECT = "/museumobject/object/create-or-update-object";
export const LIST_OBJECT_URL = "/museumobject/object/object_list";
export const OBJECT_SINGLE_DETAIL = "/museumobject/object/object_details";
export const DELETE_OBJECT = "/museumobject/object/delete_object";
export const OBJECT_DROPDOWN_URL = "/museumobject/object/object_dropdown";
export const OBJECT_BULK_UPLOAD = "/museumobject/object/object-bulk-create";
export const BULK_ACCESS = "/museumobject/object/bulk-create-accession";
export const TABLE_CHANGE = "/museumobject/object/table-bulk-update";
export const EXPORT_LIST = "/museumobject/object/export-objects";
export const CREATE_GLB = "/museumobject/object/upload-glb-images";
export const CREATE_DIGITAL =
  "/museumobject/object/update-object-digital-images";
export const CREATE_SESSION =
  "/museumobject/object-session/create-object-session";
export const CANCEL_SESSION =
  "/museumobject/object-session/save-override-cancellations";
export const NEXT_AND_PREVIOUS =
  "/museumobject/object/get-next-previous-object";
export const BASIC_INFORMATION_OBJECT =
  "/museumobject/object/get-object-basic-information";
////////////////////Object end ///////////////////

//////////////////// transit start ///////////////////
export const TRANSIT_FORM_DETAILS =
  "/transit-form/transit-form/transit-form-details";
export const CREATE_TRANSIT_FORM =
  "/transit-form/transit-form/create-or-update-transit-form";
export const TRANSIT_LIST = "/transit-form/transit-form/list-transit-froms";
export const TRANSIT_DETAILS =
  "/transit-form/transit-form/transit-form-details";
export const TRANSIT_APPROVE =
  "/transit-form/transit-form/approve-transit-request";
export const TRANSIT_HISTORY =
  "/transit-form/transit-form/transit-location-log-list";
export const UPLOAD_PDF_TRANSIT =
  "/transit-form/transit-form/upload-signed-pdf";
export const WITHDRAW_TRANSIT =
  "/transit-form/transit-form/withdraw-transit-request";
//////////////////// transit end ///////////////////

//////////////////// Object pin start ///////////////////
export const CREATE_PIN_OBJECT = "/museumobject/pin_objects/pin-object";
export const GET_PIN_OBJECT_LIST =
  "/museumobject/pin_objects/get-pinnned-objects";
export const DELETE_PIN_OBJECT =
  "/museumobject/pin_objects/delete-pinned-objects";
export const GET_PIN_PAGE_LIST =
  "/museumobject/pin_objects/get-pinned-objects-list";
//////////////////// Object pin end ///////////////////

//////////////////// building start ///////////////////

export const CREATE_BUILDING = "/location/building/create_or_update_building";
export const LIST_BUILDING = "/location/building/get_building_list";
export const BUILDING_SINGLE_DETAIL = "/location/building/get_building_details";
export const DELETE_BUILDING = "/location/building/delete_building";
export const BUILDING_DROPDOWN_URL = "/location/building/get_building_dropdown";
export const BULK_ACCESSION_LIST =
  "/museumobject/object/get-bulk-accession-records";
export const ASSIGN_USER = "/museumobject/object/assign-object";
////////////////////building end ///////////////////

//////////////////// floor start ///////////////////
export const CREATE_FLOOR_URL = "/category/Floor/create_or_update_floor";
export const LIST_FLOOR_URL = "/category/Floor/get_floor_list";
export const DELETE_FLOOR_URL = "/category/Floor/delete_floor";
export const FLOOR_SINGLE_DETAIL = "/category/Floor/get_floor_details";
export const FLOOR_LIST_DROPDOWN = "/location/floor/get_floor_dropdown";
////////////////////floor end ///////////////////

//////////////////// room start ///////////////////
export const CREATE_ROOM_URL = "/category/Room/create_or_update_room";
export const LIST_ROOM_URL = "/category/Room/get_room_list";
export const DELETE_ROOM_URL = "/category/Room/delete_room";
export const ROOM_SINGLE_DETAIL = "/category/Room/get_room_details";
export const ROOM_LIST_DROPDOWN = "/location/room/get_room_dropdown";
////////////////////room end ///////////////////

//////////////////// shelf start ///////////////////
export const CREATE_SHELF_URL = "/category/Shelf/create-or-update-shelf";
export const LIST_SHELF_URL = "/category/Shelf/get-shelf-list";
export const DELETE_SHELF_URL = "/category/Shelf/delete-shelf";
export const SHELF_SINGLE_DETAIL = "/category/Shelf/get-shelf-details";
export const SHELF_LIST_DROPDOWN =
  "/location/storagesystem/get-storage-system-dropdown";
////////////////////shelf end ///////////////////

//////////////////// rack start ///////////////////
export const CREATE_RACK_URL = "/category/Rack/create_or_update_rack";
export const LIST_RACK_URL = "/category/Rack/get_rack_list";
export const DELETE_RACK_URL = "/category/Rack/delete_rack";
export const RACK_SINGLE_DETAIL = "/category/Rack/get_rack_details";
export const RACK_LIST_DROPDOWN =
  "/location/storageunit/get-storage-unit-dropdown";
////////////////////rack end ///////////////////

//////////////////// storage start ///////////////////
export const CREATE_STORAGE_URL =
  "/location/systemtype/create-or-update-system-type";
export const LIST_STORAGE_URL = "/location/systemtype/get-system-type-list";
export const DELETE_STORAGE_URL = "/location/systemtype/get-system-type-list";
export const STORAGE_SINGLE_DETAIL =
  "/location/systemtype/get-system-type-details";
export const STORAGE_LIST_DROPDOWN =
  "/location/systemtype/get-system-type-dropdown";
////////////////////storage end ///////////////////

//////////////////// unit start ///////////////////
export const CREATE_UNIT_URL = "/location/unittype/create-or-update-unit-type";
export const LIST_UNIT_URL = "/location/unittype/get-unit-type-list";
export const DELETE_UNIT_URL = "/location/unittype/delete-unit-type";
export const UNIT_SINGLE_DETAIL = "/location/unittype/get-unit-type-details";
export const UNIT_LIST_DROPDOWN = "/location/unittype/get-unit-type-dropdown";
////////////////////unit end ///////////////////

////////////////////Notification start ///////////////////

export const LIST_NOTIFICATION = "/notification/Notification/list-notification";
export const NOTIFICATION_COUNT =
  "/notification/Notification/get-notification-count";
export const READ_ALL_NOTIFICATION =
  "/notification/Notification/change-all-notifiaction-status";
export const READ_NOTIFICATION =
  "/notification/Notification/change-notification-status";
export const NOTIFICATION_COUNT_DETAILS =
  "/notification/Notification/get-notification-details";
export const NOTIFICATION_PREFERENCE =
  "/notification/NotificationPreference/create-or-update-preference";
export const NOTIFICATION_PREFERENCE_GET =
  "/notification/NotificationPreference/get-preference";
////////////////////Notification end ///////////////////

////////////////////Conserveation start ///////////////////

export const CONSERVATION_DETAILS =
  "/museumobject/object_conservation/get-object-conservation-details";
export const CONSERVATION_CREATION =
  "/museumobject/object_conservation/create-or-update-object-conservation";
export const CONSERVATION_NEXT =
  "/museumobject/object_conservation/get-next-index-object";
export const CONSERVATION_STATUS =
  "/museumobject/object_conservation/change-conservation-status";
export const CONSERVATION_KANBAN =
  "/museumobject/conservation-kanban/update-conservation-status";
////////////////////Conservation end ///////////////////

////////////////////object degradation start ///////////////////
// export const DEGRADATION_CREATION = '/settings/action/create-or-update-action'
export const DEGRADATION_DROPDOWN =
  "/museumobject/object_conservation/get-degradation-dropdown";
////////////////////object degradation end ///////////////////

////////////////////object treatment start ///////////////////
export const TREATMENT_CREATION = "/settings/action/create-or-update-action";
export const TREATMENT_DROPDOWN = "/settings/action/get-action-dropdown";
////////////////////object treatment end ///////////////////

// ///////////object Kanaban////////////////

export const KANBAN_LIST = "/museumobject/object-kanban/get-kanban-list";
export const KANBAN_TODO = "/museumobject/object-kanban/get-kanban-to-do-list";

// //////END////////////////////////////////////////////////////////////////////

// ////////photographykanban//////////////////////////////////////////////////

export const PHOTGRAPHY_OBJECT_ASSIGED =
  "/museumobject/photography-kanban/modify-object-assigned";
export const UPDATE_PHOTOGRAPHY_STATUS =
  "/museumobject/photography-kanban/update-photography-status";

///////////////////////////////Query start//////////////////////////////////
export const CREATE_QUERIES =
  "/museumobject/object_queries/create-or-update-queries";
export const DELETE_QUERIES = "/museumobject/object_queries/delete-queries";
export const DETAILS_QUERIES =
  "/museumobject/object_queries/get-queries-details";
export const LIST_QUERIES = "/museumobject/object_queries/get-queries-list";
export const LIKE_DISLIKE_QUERIES =
  "/museumobject/object_queries/like-or-dislike-query";
export const LIKE_DISLIKE_REPLAY_QUERIES =
  "/museumobject/object_queries/like-or-dislike-replay-query";
///////////////////////////////Query end//////////////////////////////////

///////////////////////////////Global search//////////////////////////////////
export const GLOBAL_SEARCH = "/category/global-searchget-search-result";
///////////////////////////////Global search//////////////////////////////////

///////////////////////////////LM_QR START /////////////////////////////////////
export const GET_ROOM_OBJECT = `/location/lm-details/get-room-object`;
export const GET_STORAGE_SYSTEM = `/location/lm-details/get-stoarge-system-object`;
export const GET_STORAGE_UNIT = `/location/lm-details/get-storage-unit-object`;
export const QR_LOCATION = `/location/lm-details/get-gnerate-pdf-object`;

///////////////////////////////LM_QR END /////////////////////////////////////

/////////////////////////////activity log start///////////////////////////////
export const CATEGORY_NAME = "/activitylog/activity-log/category-name-log";
export const LIST_ACTIVITY = "/activitylog/activity-log/list-activity-log";
/////////////////////////////activity log end///////////////////////////////

/////////////////////////////Dashboard start///////////////////////////////
export const DASHBOARD_COUNT_URL = "/museumobject/dashboard/dashboard-count";
/////////////////////////////Dashboard end///////////////////////////////

/////////////////////////////S3 start///////////////////////////////
export const EXPORT_S3 = "/s3/sync/sync-folder";
export const GET_S3_IMAGE = "/s3/sync/get-folder-images";
/////////////////////////////S3 END///////////////////////////////

///////////////////////////// start///////////////////////////////
export const CREATE_EXHIBITION =
  "/exhibition/exhibition/create-or-update-exhibition-plan";
export const LIST_EXHIBITION =
  "/exhibition/exhibition/get-exhibition-plan-list";
export const EDIT_EXHIBITION =
  "/exhibition/exhibition/get-exhibition-plan-details";
export const DELETE_EXHIBITION =
  "/exhibition/exhibition/delete-exhibition-plan";

/////////////////////////////release start///////////////////////////////
export const CREATE_RELEASE_NOTE =
  "/settings/release_note/create-or-update-release-note";
export const LIST_RELEASE_NOTE = "/settings/release_note/get-release-note-list";
export const RELEASE_SINGLE_DETAIL =
  "/settings/release_note/get-release-note-details";
export const DELETE_RELEASE_NOTE =
  "/settings/release_note/delete-release-notes";
export const RELEASE_NOTE_ON_HOME =
  "/settings/release_note/get-latest-release-note";
export const RELEASE_NOTE_IS_READ =
  "/settings/release_note/update-release-note-status";
export const RELEASE_NOTE_UNREAD =
  "/settings/release_note/get-unread-release_notes";
/////////////////////////////release end///////////////////////////////
